import script from "./AIAssistantStartTranscription.vue?vue&type=script&setup=true&lang=ts"
export * from "./AIAssistantStartTranscription.vue?vue&type=script&setup=true&lang=ts"

import "./AIAssistantStartTranscription.vue?vue&type=style&index=0&id=e182f34a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e182f34a"]])

export default __exports__